import React, { useEffect } from "react";
import { observer } from "mobx-react";
import { PageKit } from "components/common/PageContainer/PageKit";
import { Store } from "state/store";
import { Menu } from "domain/menuOptions";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import { REPAYMENT_HOLIDAY_ATTN_URL } from "App.const";
import { useNavigate } from "react-router-dom";
import { Col } from "reactstrap";
import { RequestRepaymentHoliday } from "components/RequestRepaymentHoliday";
import { REQUEST_REPAYMENT_HOLIDAY_SCREEN_TITLE } from "./Title.const";
import { SiteDown } from "components/AppendixScreen/SiteDown";
export type RepaymentHolidayScreenProps = {
  store: Store;
};

const RepaymentHolidayScreen = ({ store }: RepaymentHolidayScreenProps) => {
  document.title = REQUEST_REPAYMENT_HOLIDAY_SCREEN_TITLE;
  const {
    menuStore,
    aboutYourLoanStore,
    selectedTreatmentStore,
    indicativeRepaymentOptionsStore,
    fetching,
    error,
  } = store;
  const initSelectedTreatments: SelectedTreatmentsDetails = {
    treatmentOptionType: Menu.RequestRepaymentHoliday,
    selectedRHType: selectedTreatmentStore.data?.selectedRHType,
    selectedOptionType: selectedTreatmentStore.data?.selectedOptionType || null,
    repaymentOption: selectedTreatmentStore.data?.repaymentOption || null,
    existingLoanDetails:
      selectedTreatmentStore.data?.existingLoanDetails || null,
  };

  const [selectedTreatments, setSelectedTreatments] =
    React.useState<SelectedTreatmentsDetails>(initSelectedTreatments);
  const [checked, setChecked] = React.useState<boolean>(false);
  const [extendTermTaken, setExtendTermTaken] = React.useState<boolean>(false);
  const navigate = useNavigate();
  const handleClick = async () => {
    await store.selectedTreatmentStore.setSelectedTreatments(
      selectedTreatments
    );
    navigate(REPAYMENT_HOLIDAY_ATTN_URL, { replace: true });
  };

  useEffect(() => {
    const updateState = async () => {
      const extendTermTaken = aboutYourLoanStore.data.fullTermExtensionTaken;
      setExtendTermTaken(extendTermTaken);
      const existingLoanDetails =
        indicativeRepaymentOptionsStore.data?.existingLoanDetails;
      existingLoanDetails &&
        setSelectedTreatments((selectedTreatments) => ({
          ...selectedTreatments,
          existingLoanDetails,
        }));
    };
    updateState();
  }, [indicativeRepaymentOptionsStore.data, aboutYourLoanStore.data]);

  if (store.hasInvalidNumberOfRepayments) {
    return (
      <>
        <PageKit
          selectedMenu={Menu.RequestRepaymentHoliday}
          menus={menuStore.data}
        />
        <Col className="content-body">
          <SiteDown message="finalRepaymentDate is invalid" />
        </Col>
      </>
    );
  }

  return (
    <>
      <PageKit
        selectedMenu={Menu.RequestRepaymentHoliday}
        menus={menuStore.data}
      />
      <Col className="content-body">
        <RequestRepaymentHoliday
          fetching={fetching}
          error={error}
          repaymentOptions={indicativeRepaymentOptionsStore.repaymentOptions}
          selectedTreatments={selectedTreatments}
          aboutYourLoan={aboutYourLoanStore.data}
          extendTermTaken={extendTermTaken}
          checked={checked}
          onChecked={setChecked}
          onChange={setSelectedTreatments}
          onClick={handleClick}
        />
      </Col>
    </>
  );
};

const RepaymentHolidayScreenObserver = observer(RepaymentHolidayScreen);
export { RepaymentHolidayScreenObserver as RepaymentHoldidayScreen };
